import { OneSignal } from "react-native-onesignal";
import {
  useDeviceTokenDeleteMutation,
  useDeviceTokenMutation,
} from "@apis/pushNotifications";
import { useSelector } from "react-redux";
import { Platform } from "react-native";

export const useOneSignalSubscriberId = () => {
  const userId = useSelector((state: any) => state.userInfo?.user?.id);
  const deviceTokenMutation = useDeviceTokenMutation();
  const deviceDeleteTokenMutation = useDeviceTokenDeleteMutation();

  const handleRegisterOneSignalToken = async () => {
    if (Platform.OS === "web") return;
    try {
      const hasPermission = await OneSignal.Notifications.getPermissionAsync();
      const canRequest = await OneSignal.Notifications.canRequestPermission();
      // After a denial, optIn() can show OneSignal's "Open Settings" alert.
      if (!hasPermission && !canRequest) {
        return;
      }
      if (hasPermission) {
        OneSignal.User.pushSubscription.optIn();
      }
      const subscriberId = await OneSignal.User.pushSubscription.getIdAsync();

      if (userId && subscriberId) {
        deviceTokenMutation.mutate(
          { userId: userId, subscriberId: subscriberId },
          {
            onError: (error) => {
              console.error("Error posting device token", error);
            },
          }
        );
      }
    } catch (error) {
      console.error("Error registering OneSignal token", error);
    }
  };

  const handleDeleteOneSignalToken = async () => {
    if (Platform.OS === "web") return;
    try {
      const subscriberId = await OneSignal.User.pushSubscription.getIdAsync();
      OneSignal.User.pushSubscription.optOut();

      if (userId && subscriberId) {
        await deviceDeleteTokenMutation.mutateAsync(
          { userId: userId, subscriberId: subscriberId },
          {
            onError: (error) => {
              console.error("Error deleting device token", error);
            },
          }
        );
      }
    } catch (error) {
      console.error("Error deleting OneSignal token", error);
    }
  };

  return {
    handleRegisterOneSignalToken,
    handleDeleteOneSignalToken,
  };
};
